import ConfigInterface from "./../customers/config-interface";
// declares a variables attached to windows through a script file in index.html
declare let config: ConfigInterface;
export const appConfig = config;
